const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';

export function base32Encode(bytes) {
  let bits = 0;
  let value = 0;
  let out = '';
  for (const b of bytes) {
    value = (value << 8) | b;
    bits += 8;
    while (bits >= 5) {
      out += ALPHABET[(value >>> (bits - 5)) & 31];
      bits -= 5;
    }
  }
  if (bits > 0) out += ALPHABET[(value << (5 - bits)) & 31];
  return out;
}

export function base32Decode(text) {
  const clean = String(text).toUpperCase().replace(/[^A-Z2-7]/g, '');
  let bits = 0;
  let value = 0;
  const out = [];
  for (const ch of clean) {
    const idx = ALPHABET.indexOf(ch);
    if (idx < 0) throw new Error('恢复码含非法字符');
    value = (value << 5) | idx;
    bits += 5;
    if (bits >= 8) {
      out.push((value >>> (bits - 8)) & 0xff);
      bits -= 8;
    }
  }
  return new Uint8Array(out);
}

/** 49 bytes = version(1) || salt(16) || masterKey(32), grouped in 5 characters. */
export function encodeRecovery(salt, masterKey) {
  const buf = new Uint8Array(1 + salt.length + masterKey.length);
  buf[0] = 1;
  buf.set(salt, 1);
  buf.set(masterKey, 1 + salt.length);
  return base32Encode(buf).match(/.{1,5}/g).join('-');
}

export function decodeRecovery(text) {
  const buf = base32Decode(text);
  if (buf.length !== 49) throw new Error('恢复码长度不正确');
  if (buf[0] !== 1) throw new Error('不支持的恢复码版本');
  return { salt: buf.slice(1, 17), masterKey: buf.slice(17, 49) };
}
